import { Component, OnInit } from '@angular/core';
import { version } from '../../../app.version';

@Component({
  selector: 'dca-footer',
  templateUrl: './footer.component.html',
  styleUrls: [ './footer.component.scss' ]
})
export class FooterComponent implements OnInit {
  version = version.numero;

  ngOnInit(): void {
  }
}
